// Campaign state stays on this device. No account details are sent to Tally.
export const SURVEY_URL = 'https://tally.so/r/pebpq8';
export const surveyCopy = {
  title: 'با نظر تو بهتر می‌شیم',
  body: 'لطفاً ۲ دقیقه برامون وقت بذارید و تجربه‌تون از VO2Peaks رو صادقانه و واقع‌بینانه بنویسید؛ هم چیزهایی که خوب بوده، هم چیزهایی که نیاز به بهتر شدن داره.',
  privacy: 'این نظرسنجی ناشناسه.',
  vpn: 'اگر لینک باز نشد، فیلترشکن رو روشن کنید و دوباره امتحان کنید.',
  open: 'باز کردن و تکمیل پرسشنامه',
  dismiss: 'بستن',
  error: 'لینک باز نشد. دوباره امتحان کنید یا آدرس زیر رو در مرورگر باز کنید.',
};

export function surveyStorageKey(userId: string | number): string {
  return `vo2:survey:pebpq8:shown:${userId}`;
}

export interface SurveyStorage {
  getItem(key: string): Promise<string | null> | string | null;
  setItem(key: string, value: string): Promise<void> | void;
}

// Also suppress remounts when device storage is unavailable.
const shownThisSession = new Set<string>();

export async function hasSeenSurvey(storage: SurveyStorage, key: string): Promise<boolean> {
  if (shownThisSession.has(key)) return true;
  try {
    return (await storage.getItem(key)) !== null;
  } catch {
    return false;
  }
}

export async function markSurveyShown(storage: SurveyStorage, key: string): Promise<void> {
  shownThisSession.add(key);
  try {
    await storage.setItem(key, '1');
  } catch {
    // A storage failure must never block access to the app or the questionnaire.
  }
}
